import axios from 'axios'
import DataManager from '@/assets/DataManager.js'
import SearchDataParser from '@/assets/SearchDataParser.js'
import HelperFunctions from '@/assets/HelperFunctions.js'

const Profile = new function() {
  this.userData = false;
  this.loginType = false;
  this.loggedIn = false;
  this.userKey = false;
  this.tagList;
  this.menuList;
  this.searchDataExpanded;

  this.login = function(userEmail, userPassword, rememberLogin) {
    return new Promise((resolve) => {
      const params = new URLSearchParams();
      params.append('action', 'login');
      params.append('email', userEmail);
      params.append('pass', userPassword);
      axios({
        method: 'post',
        url: 'https://apps.odenserundt.dk/apptools/orApi/',
        data: params
      }).then((response) => {
        console.log(response);
        if(response.data.type == 'login_ok') {
          this.loginType = 'user';
          this.loggedIn = true;
          this.userKey = response.data.key;
          if(rememberLogin) {
            this.saveLogin(response.data.key, 'user');
          }
          else {
            this.tempSaveLogin(response.data.key, 'user');
          }
          resolve(response);
        }
        else {
          resolve(response);
        }
      });
    });
  };

  this.saveLogin = function(key, type) {
    localStorage.setItem('OdenseRundt-Login', JSON.stringify({key: key, type: type, timeStamp: Date.now(), tempTimeStamp: false}));
  };

  this.tempSaveLogin = function(key, type) {
    localStorage.setItem('OdenseRundt-Login', JSON.stringify({key: key, type: type, timeStamp: false, tempTimeStamp: Date.now()}));
  };

  this.logout = function() {
  	if(this.loginType == 'facebook') {
  		this.userData = [];
			FB.getLoginStatus(function(response) {
				//if(response.status === 'connected') {
					FB.logout(function(response) {
						//console.log(response);
					});
				//}
			});
  	}
  	else if(this.loginType == 'user') {
  		this.userData = [];
  	}
  	this.userKey = false;
  	this.loggedIn = false;
  	localStorage.removeItem('OdenseRundt-Login');
		setTimeout(function() {
			window.location.reload();
		}, 1000);
  };

  this.checkForPreviousLogin = function() {
    var loginInfo = localStorage.getItem('OdenseRundt-Login');
    if(loginInfo !== undefined && loginInfo !== null && loginInfo !== 'undefined') {
      loginInfo = JSON.parse(loginInfo);
  		var timeNow = Date.now();
  		var loginOk = false;
  		var tempLoginTime = loginInfo.tempTimeStamp;
  		var prevLoginTime = loginInfo.timeStamp;
  		//console.log(timeNow);
  		//Check for temp login
  		if((timeNow - tempLoginTime) < 1800000) {
  			console.log('TempLogin Ok');
  			loginOk = true;
  		}
  		else if((timeNow - prevLoginTime) > 604800000) {
  			//Check if login was saved more than 7 days ago
  			console.log('Login udløbet');
  		}
  		else {
  			loginOk = true;
  		}

  		if(loginOk) {
  			//console.log('Prev login:', login);
  			this.userKey = loginInfo.key;
  			this.loginType = 'user';
        this.loggedIn = true;
  			this.getUserData();
  		}
  	}
  	else {
  		console.log('Intet tidligere login');
  	}
  };

  this.checkIfItemIsLiked = function(type, id) {
  	var itemLiked = false;
  	for(var i = 0; i < this.userData.likes.length; i++) {
      if(type == 'link') {
        if(this.userData.likes[i].type == type && this.userData.likes[i].linkId == id) {
    			itemLiked = true;
    		}
      }
      else {
        if(this.userData.likes[i].type == type && this.userData.likes[i].value == id) {
    			itemLiked = true;
    		}
      }
  	}
    return itemLiked;
  };

  this.checkIfItemIsInUserGroup = function(type, id) {
  	var itemFound = false;
  	for(var i in this.userData.groups) {
  		for(var k in this.userData.groups[i].likes) {
        if(type == 'link') {
          if(this.userData.groups[i].likes[k].type == type && this.userData.groups[i].likes[k].linkId == id) {
    				itemFound = true;
    			}
        }
        else {
          if(this.userData.groups[i].likes[k].type == type && this.userData.groups[i].likes[k].value == id) {
    				itemFound = true;
    			}
        }
  		}
  	}
  	return itemFound;
  };

  this.like = function(options) {
    return new Promise((resolve) => {
    	var likes = [[parseInt(options.id), options.type]];
      var data = {action: 'like', key: this.userKey, likes: likes};
      $.ajax({
    		type: 'POST',
    		async: false,
    		url: 'https://apps.odenserundt.dk/apptools/orApi/',
    		data: data,
    		success: (data) => {
          data = JSON.parse(data);
          if(options.type == 'link') {
            var item = {likeId: data.likes[0].id, type: options.type, value: options.http, image: options.img, name: options.name, linkId: options.id, http: options.http};
          }
          else if(options.type == 'place') {
            var item = {likeId: data.likes[0].id, type: options.type, value: options.id, image: options.img, name: options.name, tagId: options.tagId};
          }
          else {
            var item = {likeId: data.likes[0].id, type: options.type, value: options.id, image: options.img, name: options.name};
          }
          this.userData.likes.push(item);
          HelperFunctions.trackSession('like', options.type+'-'+options.id);
          resolve(item);
          //console.log(this.userData.likes);
    		},
    		error: function (xhr, ajaxOptions, thrownError) {
    			console.log(xhr, ajaxOptions, thrownError);
    		}
    	});
    });
  };

  this.unlike = function(type, id) {
    console.log('Unlike', type, id);
    for(var i in this.userData.likes) {
      if(this.userData.likes[i].type == 'link' && this.userData.likes[i].linkId == id || this.userData.likes[i].type == type && this.userData.likes[i].value == id) {
        //console.log(this.userData.likes[i]);
        if(type == 'link') {
          id = this.userData.likes[i].likeId;
        }
        this.userData.likes.splice(i, 1);
        break;
      }
    }
  	//Remove from usergroups
  	for(var i = 0; i < this.userData.groups.length; i++) {
  		for(var k = 0; k <this.userData.groups[i].likes.length; k++) {
  			if(type == 'link') {
  				if(this.userData.groups[i].likes[k].type == type && this.userData.groups[i].likes[k].linkId == id) {
  					this.userData.groups[i].likes.splice(k, 1);
  				}
  			}
  			else {
  				if(this.userData.groups[i].likes[k].type == type && this.userData.groups[i].likes[k].value == id) {
  					this.userData.groups[i].likes.splice(k, 1);
  				}
  			}
  		}
  	}

    const params = new URLSearchParams();
    params.append('action', 'unlike');
    params.append('key', this.userKey);
    params.append('id', id);
    params.append('type', type);

    axios({
      method: 'post',
      url: 'https://apps.odenserundt.dk/apptools/orApi/',
      data: params
    }).then((response) => {
      console.log(response.data);
    });
  };

  this.createNewGroup = function(groupName) {
    const params = new URLSearchParams();
    params.append('action', 'createGroup');
    params.append('key', this.userKey);
    params.append('name', groupName);

    axios({
      method: 'post',
      url: 'https://apps.odenserundt.dk/apptools/orApi/',
      data: params
    }).then((response) => {
      console.log(response);
      var item = {id: response.data.groupId, name: groupName, likes: []};
      this.userData.groups.unshift(item);
      HelperFunctions.trackSession('user-group', 'new');
    });
  };

  this.renameGroup = function(groupId, name) {
    const params = new URLSearchParams();
    params.append('action', 'renameGroup');
    params.append('key', this.userKey);
    params.append('groupId', groupId);
    params.append('name', name);
    axios({
      method: 'post',
      url: 'https://apps.odenserundt.dk/apptools/orApi/',
      data: params
    }).then((response) => {
      console.log(response);
      for(var i in this.userData.groups) {
        if(this.userData.groups[i].id == groupId) {
          this.userData.groups[i].name = name;
          break;
        }
      }
    });
  };

  this.deleteGroup = function(groupId) {
    const params = new URLSearchParams();
    params.append('action', 'deleteGroup');
    params.append('key', this.userKey);
    params.append('groupId', groupId);
    axios({
      method: 'post',
      url: 'https://apps.odenserundt.dk/apptools/orApi/',
      data: params
    }).then((response) => {
      console.log(response);
      for(var i in this.userData.groups) {
        if(this.userData.groups[i].id == groupId) {
          this.userData.groups.splice(i, 1);
        }
      }
    });
  };

  this.addContentToGroup = function(groupId, content) {
    var likes = [];
    for(var i in content) {
      likes.push(content[i].likeId)
    }
    var data = {action: 'groupLikes', key: this.userKey, groupId: groupId, likes: likes};

    $.ajax({
  		type: 'POST',
  		async: false,
  		url: 'https://apps.odenserundt.dk/apptools/orApi/',
  		data: data,
  		success: (data) => {
        data = JSON.parse(data);
  			console.log(data);
        for(var i in this.userData.groups) {
          if(this.userData.groups[i].id == groupId) {
            this.userData.groups[i].likes = content;
          }
        }
  		},
  		error: function (xhr, ajaxOptions, thrownError) {
  			console.log(xhr, ajaxOptions, thrownError);
  		}
  	});
  };

  this.addUserAddress = function(options) {
    return new Promise((resolve) => {
      var address = [[JSON.stringify(options), 'address']];
      var data = {action: 'like', key: this.userKey, likes: address};

      $.ajax({
    		type: 'POST',
    		async: false,
    		url: 'https://apps.odenserundt.dk/apptools/orApi/',
    		data: data,
    		success: (data) => {
          data = JSON.parse(data);
          console.log(data);
          var item = {likeId: data.likes[0].id, type: 'address', name: options.name, alias: options.alias, coords: options.coords};
          this.userData.likes.push(item);
          HelperFunctions.trackSession('new-user-address', options.name);
          resolve();
          //console.log(this.userData.likes);
    		},
    		error: function (xhr, ajaxOptions, thrownError) {
    			console.log(xhr, ajaxOptions, thrownError);
    		}
    	});
    });
  };

  this.deleteUserAddress = function(id) {
    return new Promise((resolve) => {
      const params = new URLSearchParams();
      params.append('action', 'unlike');
      params.append('key', this.userKey);
      params.append('id', id);
      params.append('type', 'address');

      axios({
        method: 'post',
        url: 'https://apps.odenserundt.dk/apptools/orApi/',
        data: params
      }).then((response) => {
        console.log(response.data);
        for(var i in this.userData.likes) {
          if(this.userData.likes[i].type == 'address' && this.userData.likes[i].likeId == id) {
            this.userData.likes.splice(i, 1);
            break;
          }
        }
        resolve();
      });
    });
  };

  this.getUserData = function() {
    return new Promise((resolve) => {
      if(this.loggedIn == true) {
        if(this.userData == false) {
          const params = new URLSearchParams();
          params.append('action', 'get');
          params.append('key', this.userKey);
          axios({
            method: 'post',
            url: 'https://apps.odenserundt.dk/apptools/orApi/',
            data: params
          }).then((response) => {
            //console.log(response);
            this.userData = response.data.data;
            console.log(this.userData);
            resolve(response.data.data);
          });
        }
        else {
          resolve(this.userData);
        }
      }
    });
  };

  this.getNecessaryData = function() {
    var promise = new Promise((resolve) => {
      DataManager.getData([
        DataManager.tagList,
        DataManager.searchData,
        DataManager.searchDataExpanded,
        DataManager.menuList,
      ], (response) => {
        this.tagList = response[0].data;
        this.searchDataExpanded = SearchDataParser(response[1].data, response[2].data).searchDataExpanded;
        this.menuList = response[3].data;
        resolve();
        //console.log(this.userData);
        //console.log(this.searchDataExpanded);
        //console.log(this.tagList);
      });
    });

    return promise;
  };

  this.getLikeData = function(array, isUserGroup) {
    //console.log(array);
    return new Promise((resolve) => {
      this.getNecessaryData().then(() => {
        let temp = {
          'address': [],
          'link': [],
          'place': [],
          'themes': [],
        };
        let groupTemp = [];

        if(array.length != 0) {
          array.forEach(likeItem => {
            if(likeItem.type == 'address') {
              if(likeItem.value) {
                var data = JSON.parse(likeItem.value);
                likeItem.name = data.name;
                likeItem.coords = data.coords;
                likeItem.alias = data.alias;
              }
            }
            //Links
            if(likeItem.type == 'link') {
              if(!likeItem.http) {
                likeItem.http = likeItem.value;
              }
              if(likeItem.image == undefined || likeItem.image == 0 || likeItem.image == null || likeItem.image == false) {
                likeItem.image = '/img/missingImg.jpg';
              }
              else if(likeItem.image.indexOf('http') == -1 && likeItem.image.indexOf('missingImg') == -1 && likeItem.image.indexOf('brokenlink') == -1) {
                likeItem.image = 'https://apps.odenserundt.dk/media/images/480/'+likeItem.image;
              }
            }

            //Place
            if(likeItem.type == 'place') {
              let place = this.searchDataExpanded.find(feature => feature.placeId == likeItem.value);
              if(likeItem.tagId == undefined && place != undefined) {
                likeItem.tagId = place.tagId;
              }

              let tag;
              for(var k in this.tagList) {
                if(this.tagList[k].id == likeItem.tagId) {
                  tag = this.tagList[k];
                  //console.log(tag);
                }
              }

              if(tag != undefined) {
                if(likeItem.archived) {
                  if(likeItem.name == undefined) {
                    likeItem.name = '';
                    this.getArchived('place', likeItem.value).then((data) => {
                      likeItem.name = data.name;
                    });
                  }
                }
                else {
                  if(place != undefined) {
                    likeItem.name = place.name;
                    likeItem.tagName = tag.name;
                    if(likeItem.image == undefined || likeItem.image == 0 || likeItem.image == null || likeItem.image == false) {
                      likeItem.image = '/img/missingImg.jpg';
                    }
                    else if(likeItem.image.indexOf('http') == -1 && likeItem.image.indexOf('missingImg') == -1 && likeItem.image.indexOf('brokenlink') == -1) {
                      likeItem.image = 'https://apps.odenserundt.dk/media/images/480/'+likeItem.image;
                    }
                  }
                  else {
                    likeItem.itemBroke = true;
                  }
                }
              }
              else {
                likeItem.itemBroke = true;
                if(likeItem.name == undefined) {
                  likeItem.name = '';
                  this.getArchived('place', likeItem.value).then((data) => {
                    likeItem.name = (data.type == 'error.notfound') ? 'Slettet sted' : data.name;
                  });
                }
              }
            }

            //Tag
            if(likeItem.type == 'tag') {
              if(likeItem.archived) {
                if(likeItem.name == undefined) {
                  likeItem.name = '';
                  this.getArchived('tag', likeItem.value).then((data) => {
                    likeItem.name = (data.type == 'error.notfound') ? 'Arkiveret tema' : data.name;
                  });
                }
              }
              else {
                let tag;
                for(var k in this.tagList) {
                  if(this.tagList[k].id == likeItem.value) {
                    tag = this.tagList[k];
                  }
                }
                if(tag != undefined) {
                  likeItem.name = tag.name_plural;
                  if(likeItem.image == undefined || likeItem.image == 0 || likeItem.image == null || likeItem.image == false) {
                    likeItem.image = '/img/missingImg.jpg';
                  }
                  else if(likeItem.image.indexOf('http') == -1 && likeItem.image.indexOf('missingImg') == -1 && likeItem.image.indexOf('brokenlink') == -1) {
                    likeItem.image = 'https://apps.odenserundt.dk/media/images/480/'+likeItem.image;
                  }
                }
                else {
                  likeItem.itemBroke = true;
                }
              }
            }

            //Group
            if(likeItem.type == 'group') {
              var likedGroup;
              if(likeItem.name == undefined || likeItem.image == undefined || likeItem.image.indexOf('http') == -1) {
                this.menuList.forEach((obj) => {
                  if(obj.id == likeItem.value) {
                    likedGroup = obj;
                  }
                  else {
                    for(var k in obj.children) {
                      if(obj.children[k].id == likeItem.value) {
                        likedGroup = obj.children[k];
                        break;
                      }
                      else if(obj.children[k].type == 'group') {
                        for(var j in obj.children[k].children) {
                          if(obj.children[k].children[j].id == likeItem.value) {
                            likedGroup = obj.children[k].children[j];
                            break;
                          }
                        }
                      }
                    }
                  }
                });
                if(likedGroup != undefined) {
                  var archived = false;
                  if(likedGroup.endDate) {
                    var itemExpired = HelperFunctions.checkExpireDate(likedGroup);
                    archived = (itemExpired) ? true : false;
                  }
                  if(!archived) {
                    likeItem.name = likedGroup.title;
                    likeItem.image = likedGroup.media;
                    if(likeItem.image == undefined) {
                      likeItem.image = '/img/missingImg.jpg';
                    }
                    if(likeItem.image.indexOf('http') == -1 && likeItem.image.indexOf('missingImg') == -1 && likeItem.image.indexOf('brokenlink') == -1) {
                      likeItem.image = 'https://apps.odenserundt.dk/media/images/480/'+likeItem.image;
                    }
                  }
                  else {
                    likeItem.name = '';
                    this.getArchived('group', likeItem.value).then((data) => {
                      likeItem.name = (data.type == 'error.notfound') ? 'Arkiveret tema' : data.name;
                      likeItem.itemBroke = true;
                      likeItem.archived = true;
                    });
                  }
                }
                else {
                  likeItem.archived = true;
                  likeItem.name = '';
                  this.getArchived('group', likeItem.value).then((data) => {
                    likeItem.name = (data.type == 'error.notfound') ? 'Slettet tema' : data.name;
                    likeItem.itemBroke = true;
                  });
                }
              }
            }

            if(isUserGroup) {
              groupTemp.push(likeItem);
            }
            else {
              if(likeItem.type == 'group' || likeItem.type == 'tag') {
                temp['themes'].push(likeItem);
              }
              else {
                temp[likeItem.type].push(likeItem);
              }
            }
          });

          if(isUserGroup) {
            resolve(groupTemp);
          }
          else {
            for(var i in temp) {
              HelperFunctions.sortArrayByString(temp[i], 'name');
            }
            resolve(temp);
          }
        }
        else {
          resolve(temp);
        }
      });
    });
  };

  this.getArchived = function(type, id) {
    return new Promise((resolve) => {
      const params = new URLSearchParams();
      params.append('action', 'getarchived');
      params.append('type', type);
      params.append('id', id);

      axios({
        method: 'post',
        url: 'https://apps.odenserundt.dk/apptools/orApi/',
        data: params
      }).then((response) => {
        resolve(response.data);
      });
    });
  };

  this.setCycleSpeed = function(value) {
    var data = {action: 'setData', key: this.userKey, data: {cycleSpeed: value}};
    $.ajax({
  		type: 'POST',
  		async: false,
  		url: 'https://apps.odenserundt.dk/apptools/orApi/',
  		data: data,
  		success: (data) => {
        this.userData.userData.cycleSpeed = value;
        HelperFunctions.trackSession('bicycle-speed', value);
  		},
  		error: function (xhr, ajaxOptions, thrownError) {
  			console.log(xhr, ajaxOptions, thrownError);
  		}
  	});
  };

  this.requestNewPassword = function() {
    return new Promise((resolve) => {
      const params = new URLSearchParams();
      params.append('action', 'resetPass');
      params.append('email', Profile.userData.email);

      axios({
        method: 'post',
        url: 'https://apps.odenserundt.dk/apptools/orApi/',
        data: params
      }).then((response) => {
        resolve();
  		});
    });
  };

  this.deleteFavorites = function() {
    const params = new URLSearchParams();
    params.append('action', 'purgeFavourites');
    params.append('key', Profile.userKey);
    axios({
      method: 'post',
      url: 'https://apps.odenserundt.dk/apptools/orApi/',
      data: params
    }).then((response) => {
      //console.log(response.data);
    });

    Profile.userData.likes = [];

    setTimeout(function() {
      window.location.reload();
    }, 1000);
  };

  this.deleteUserData = function() {
    const params = new URLSearchParams();
    params.append('action', 'purgeData');
    params.append('key', Profile.userKey);

    axios({
      method: 'post',
      url: 'https://apps.odenserundt.dk/apptools/orApi/',
      data: params
    }).then((response) => {
      //console.log(response.data);
    });
    Profile.userData = [];
    setTimeout(function() {
      window.location.reload();
    }, 1000);
  };

  this.deleteUser = function(facebook) {
    return new Promise((resolve) => {
      const params = new URLSearchParams();
      params.append('action', 'deleteUser');
      params.append('key', this.userKey);
      if(facebook) {
        params.append('facebook', true);
      }
      axios({
        method: 'post',
        url: 'https://apps.odenserundt.dk/apptools/orApi/',
        data: params
      }).then((response) => {
        //console.log(response.data);
        resolve();
      });
    });
  };
};

export default Profile;
